export default __webpack_public_path__ + "static/media/MO_profile_event_banner2.abb316a0.png";